import { ExperimentStore } from 'bernie-plugin-mobx';

import { getBucketValueByExperimentName } from 'utility';

const EXPERIMENT_NAME = 'EGTNL_Air_Smart_Shopping';

export const airSmartShopping = {
  shouldRender: (experiment: ExperimentStore): boolean => {
    return getBucketValueByExperimentName(experiment, EXPERIMENT_NAME) === 1;
  }
};
